import './polyfill';
import * as rtCore from 'vue-xcore';
import * as ui from './ui';
import * as util from './util';

export default { ...rtCore, ...ui, ...util };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/index.js